export default __webpack_public_path__ + "media/ffd32ec12754770ba2ce139941f2e00326598f891697e13c82615a1371b22b25.svg";